import { em } from 'polished'
import styled from 'styled-components'

import ControlSliderArrows from 'components/ControlSliderArrows'

export const FrameMacSlide = styled.div`
  width: 100%;
  height: auto !important;
  overflow: hidden;
`

export const ControlSliderArrowsStyled = styled(ControlSliderArrows)`
  margin-top: ${em(20)};
  margin-bottom: ${em(20)};
`
